import React from 'react';
import './WelcomeImageInspector.css';

function WelcomeImageInspector({ 
  func, 
  index, 
  onUpdate,
  setActivePhotoPreview,
  setIsPhotoPickerOpen,
  bringToFront
}) {
  const handleChange = (key, value) => {
    const newProps = {
      ...func.props,
      [key]: value
    };
    onUpdate(index, newProps);
  };

  return (
    <div className="welcome-image-inspector">
      <div className="names-editor">
      <div className="name-input-group">
        <label>Background Image</label>
        <div 
          className="image-preview"
          onClick={(e) => {
            console.log('Image preview clicked');
            // Only store the index - no handler function
                          setActivePhotoPreview({ index });
              setIsPhotoPickerOpen(true);
              bringToFront('photoPicker');
              e.stopPropagation();
          }}
          title="Click to change photo"
        >
          {func.props.backgroundImage ? (
            <img 
              src={func.props.backgroundImage} 
              alt="Preview"
              onError={(e) => e.target.style.display = 'none'}
              onLoad={(e) => e.target.style.display = 'block'}
            />
          ) : (
            <div className="empty-preview">
              Click to select image
            </div>
          )}
        </div>
        <input
          type="text"
          className="image-url-input"
          value={func.props.backgroundImage || ''}
          onChange={(e) => handleChange('backgroundImage', e.target.value)}
          placeholder="Background image URL"
        />
      </div>

        <div className="name-input-group">
          <label>First Name</label>
          <input
            type="text"
            value={func.props.name1 || ''}
            onChange={(e) => handleChange('name1', e.target.value)}
            placeholder="Enter first name"
          />
        </div>

        <div className="name-input-group">
          <label>Connecting Symbol</label>
          <input
            type="text"
            value={func.props.plusText || ''}
            onChange={(e) => handleChange('plusText', e.target.value)}
            placeholder="Enter connecting symbol"
          />
        </div>
        
        <div className="name-input-group">
          <label>Second Name</label>
          <input
            type="text"
            value={func.props.name2 || ''}
            onChange={(e) => handleChange('name2', e.target.value)}
            placeholder="Enter second name"
          />
        </div>
      </div>
    </div>
  );
}

export default WelcomeImageInspector; 